/** Workspace Settings 全页的 tab id，对应 `?setting=` 的取值。 */
export type WorkspaceSettingsTabId =
    | 'profile'
    | 'workspace'
    | 'members'
    | 'plan'
    | 'usage'
    | 'skills'
    | 'api-keys'
    | 'github';

export const SETTINGS_TAB_IDS: readonly WorkspaceSettingsTabId[] = [
    'profile',
    'workspace',
    'members',
    'plan',
    'usage',
    'skills',
    'api-keys',
    'github',
];

/** 未指定 tab 打开 Settings 时的首项（Account）。 */
export const DEFAULT_SETTINGS_TAB: WorkspaceSettingsTabId = 'profile';

export function isSettingsTabId(value: string | undefined): value is WorkspaceSettingsTabId {
    return Boolean(value && SETTINGS_TAB_IDS.includes(value as WorkspaceSettingsTabId));
}
